import { useState } from "react";
import Typography from "../../../components/Typography/Typography";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import BatchSelection from "./BatchSelection";
import BatchRecords from "./BatchRecords/BatchRecords";
import BatchVisualization from "./BatchVisualization";
import Button from "../../../components/Button/Button";
import { useModal } from "../../../hooks/modalsHooks";
import AIAssistPage from "./AiAssistPage/AIAssistPage";

const DataEntry = () => {
    const { id } = useParams();
    const { showModal } = useModal();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [selectedBatch, setSelectedBatch] = useState(null);

    const isAIAssistMode = searchParams.get("view") === "ai-assist";
    const isAIAssistEnabled =
        process.env.REACT_APP_DOCUMENT_AI_ENABLED === "true";

    const handleAddNewMaterial = () => {
        showModal({
            modalType: "AddRecordModal",
            modalProps: {
                id,
                selectedBatch,
            },
        });
    };

    const handleAIAssist = () => {
        navigate(`?view=ai-assist`);
    };

    const handleBackToDataEntry = () => {
        navigate(`?view=data-entry`);
    };

    // If we're in AI assist mode, show the AI page
    if (isAIAssistMode) {
        return (
            <AIAssistPage
                onBack={handleBackToDataEntry}
                batchId={selectedBatch?.value}
            />
        );
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 pt-2">
                    <Typography variant="h2" className="mb-4 text-2xl">
                        Data Entry
                    </Typography>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card p-3 border-0 rounded-3">
                        <Typography variant="h3" className="pb-1 text-lg">
                            Batch Selection
                        </Typography>
                        <BatchSelection
                            id={id}
                            selectedBatch={selectedBatch}
                            setSelectedBatch={setSelectedBatch}
                        />
                    </div>
                </div>
            </div>

            {selectedBatch && (
                <div className="row mt-4">
                    <BatchVisualization
                        selectedBatch={selectedBatch}
                        defaultCollapsed={true}
                    />

                    <div className="col-12 my-4">
                        <div className="card p-3 border-0 rounded-3">
                            <div className="d-flex align-items-center justify-content-between pb-3">
                                <Typography
                                    variant="h3"
                                    className="text-lg mb-0"
                                >
                                    Batch Records
                                </Typography>
                                <div className="d-flex gap-2">
                                    <Button
                                        className="btn btn-primary"
                                        fullWidth={false}
                                        onClick={handleAddNewMaterial}
                                    >
                                        Add Records
                                    </Button>
                                    {isAIAssistEnabled && (
                                        <Button
                                            fullWidth={false}
                                            onClick={handleAIAssist}
                                            variant="secondary"
                                        >
                                            <i className="bi bi-stars me-1"></i>
                                            AI Assist
                                        </Button>
                                    )}
                                </div>
                            </div>

                            <BatchRecords
                                id={id}
                                selectedBatch={selectedBatch}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DataEntry;
